import React from "react";

import clsx from "clsx";
import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-project-submission-workflow.png";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";
import TimelineContent from "./timeline-content";

const title = "Installer Project Submission";

const ProjectSubmission = () => (
  <div className={clsx("timeline-section-wrapper", styles.timelineSectionWrapper)}>
    <HeroSection title={title} className={styles.timelineSection}>
      <div className={styles.timelineSectionGrid}>
        <TimelineContent
          title={title}
          description="After your customers sign, transfer their data automatically to the installer. With Enerflo’s integrations and customized configurations, project submission is seamlessly automated, regardless of the installer CRM or submission process. Enerflo intelligently alerts reps of any outstanding items to submit a clean deal and confirms when it’s been successfully submitted. No manual entry. No emails. No separate logins. Only automation. Geez... Enerflo thought of everything."
          icon={
            <Image
              src="/images/icons/project-submission.svg"
              alt="Icon - Enerflo Project Submission"
              layout="responsive"
              height={67}
              width={60}
              quality={100}
              className="crispImage"
            />
          }
        />
        <figure className={clsx(styles.timelineFigure, styles.offsetContent)}>
          <div className="mx-auto xs:w-2/3 md:w-[125%] md:ml-[-25%]">
            <Image
              src={FigureImage}
              alt="The Enerflo Project Submission feature eliminates incomplete deals from ever being submitted and when ready, seamlessly transfers all the required customer data to the installer."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
      </div>
    </HeroSection>
  </div>
);

export default ProjectSubmission;
